<template>
  <a-modal
    v-model="visible"
    width="700px"
    class="offerDomStyle"
    :title="title"
    centered
    @ok="confirm"
    @cancel="cancel"
  >
    <a-form-model ref="addressForm" :rules="rules" :model="form" label-align="right" v-bind="formItemLayout">
      <a-form-model-item label="原出价">
        <span class="textStyle">{{detail.negotiationBid.customerBidCost ? `${detail.negotiationBid.customerBidCost}元` : ''}}</span>
      </a-form-model-item>
      <a-form-model-item label="司机报价">
        <span class="textStyle">{{detail.negotiationBid.driverBidCostTax ? `${detail.negotiationBid.driverBidCostTax}元` : '无人报价'}}</span>
      </a-form-model-item>
      <a-form-model-item label="新出价" prop="bidPrice">
        <a-input v-model.number="form.bidPrice" class="inputStyle" placeholder="请输入金额" :max-length="2" type="number" @change="totalPrice" />
        <a-select v-model="form.bidUnit" disabled style="width: 120px">
            <a-select-option v-for="text in bidUnitList" :key="text" :value="text">
                {{text}}
            </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="取货时间" prop="startTime">
        <a-date-picker
          v-model="form.startTime"
          :show-time="{ defaultValue: defaultTime }"
          placeholder="请选择" 
        />
      </a-form-model-item>
      <a-form-model-item label="总价">
        <span class="numStyle">{{ filterNumber() }}</span>
      </a-form-model-item>
      <a-form-model-item label="自动确认">
        <a-switch v-model="form.autoConfirm" /> <span class="tipsStyle">司机报价低于或等于我的出价时订单自动确认</span>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { transportBid } from '../api'

const bidUnitList = ['元/单','元/吨','元/方']

export default {
  name: 'OfferDom',
  props: {
    detail: {
      type: Object,
      default: ()=>{}
    }
  },
  data() {
    const valiNumber = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入金额'));
      } else if (value * 1 < 0 || value * 1 > 99999.99) {
        callback(new Error("请输入大于0且小于99999.99的金额"));
      } else {
        callback();
      }
    };
    const valiDate = (rule, value, callback) => {
      if (value === '' || value === null) {
        callback(new Error('请选择取货时间'));
      } else {
        const timer = moment(value).valueOf()
        const start = moment().add(3, 'hours').valueOf()
        if(timer < start){
          callback(new Error("取货时间不能小于当前时间加3小时"));
        }
      }
      callback();
    };
    return {
      visible: true,
      title: '重新出价',
      defaultTime: moment('00:00:00', 'HH:mm:ss'),
      form: {
        unifyOdrNo: '',
        bidPrice: '', // 货主出价
        bidUnit: bidUnitList[0], // 报价单位(元/单、元/吨、元/方)
        customerBidCost: '', // 货主出价总金额
        startTime: '', // 取货时间
        autoConfirm: true, // 是否自动确认
      },
      rules: {
        bidPrice: [{ required: true, validator: valiNumber, trigger: 'change' },],
        startTime: [{ required: true, validator: valiDate, trigger: 'change' }],
      },
      formItemLayout: {
        wrapperCol: { span: 14 },
        labelCol: { span: 4 },
        labelAlign: 'left'
      },
      bidUnitList,
    };
  },
  watch: {
    detail:{
      handler(val){
        this.form.bidUnit = val.negotiationBid?.bidUnit || bidUnitList[0]
        this.form.unifyOdrNo = val.unifyOrderNo
        const time = val.startStation.startTime
        const start = moment().add(3, 'hours').valueOf()
        if(time > start){
          this.form.startTime = moment(time)
        } else {
          this.form.startTime = moment(start)
        }
      },
      immediate: true
    }
  },
  methods: {
    async confirm() {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          transportBid(this.form).then(() => {
            this.$message.success('出价成功')
            this.$emit('update')
          })
        }
      })
    },
    cancel(){
      this.$emit('cancel')
    },
    totalPrice(){
      if(this.form.bidUnit !== bidUnitList[0]){
        let weight = 0
        let volume = 0
        
        this.detail.endStations.forEach((e) => {
          e.stationGoodsList.forEach((n) => {
            weight += n.weight ? n.weight * 1 : 0
            volume += n.volume ? n.volume * 1 : 0
          })
        })
        if(this.form.bidUnit === bidUnitList[1]){
          this.form.customerBidCost = this.form.bidPrice * 1 * (weight / 1000)
        } else {
          this.form.customerBidCost = this.form.bidPrice * 1 * volume
        } 
      } else {
        this.form.customerBidCost = this.form.bidPrice * 1
      }
    },
    filterNumber(){
      if(this.form.customerBidCost){
        return (this.form.customerBidCost * 1).toFixed(2)
      }
      return '--'
    }
  },
}
</script>

<style lang="less" scoped>
/deep/ .ant-modal-header{
  background-color: #F4F5F6;
  .ant-modal-title{
    font-weight: bold !important;
  }
}
.inputStyle{
  width: 200px;
  margin-right: 16px;
}
.textStyle{
  color: #171717;
  font-size: 17px;
  font-weight: bold;
}
.numStyle{
  color: #ED4934;
  font-size: 17px;
  font-weight: bold;
}
.tipsStyle{
  font-size: 12px;
  color: #CCCCCC;
  margin-left: 13px;
  font-weight: bold;
}
</style>